<script lang="ts">
    import { writable } from 'svelte/store'

    export const globalAlert = writable(null)

    window.alert = (alert: any) => {
        globalAlert.update((_) => alert)
    }

    let localAlert

    globalAlert.subscribe((value) => {
        localAlert = value
    })

    let arrayErrors = []
    $: {
        if (!localAlert) {
            arrayErrors = []
        } else if (typeof localAlert === 'string') {
            arrayErrors.push(localAlert)
        } else if (Array.isArray(localAlert)) {
            arrayErrors = localAlert
        } else if (typeof localAlert === 'object') {
            if (localAlert.message) {
                arrayErrors.push(localAlert.message)
            } else {
                arrayErrors.push(String(localAlert))
            }
        }
    }

    function closePopup() {
        globalAlert.set(null)
        // //if (close) close()
        // svelteDispatch('close', null)
        // component?.dispatchEvent(new CustomEvent('close', null))
    }
</script>

{#if arrayErrors?.length > 0}
    <div class="root-alert">
        <div class="box">
            <div class="title">Alerta</div>
            {#if arrayErrors.length === 1}
                <div class="errors">
                    {@html arrayErrors[0].replaceAll('\n', '<br />')}
                </div>
            {:else}
                <ul class="errors">
                    {#each arrayErrors as error}
                        <li>{@html error.replaceAll('\n', '<br />')}</li>
                    {/each}
                </ul>
            {/if}
            <button on:click={closePopup}>Ok</button>
        </div>
    </div>
{/if}

<style>
    .root-alert {
        top: 0px;
        left: 0px;
        position: fixed;
        padding: 8px;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        width: 100vw;
        background: #000000aa;
    }
    .root-alert .box {
        min-width: 200px;
        max-width: 600px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        background: #282828;
        border-radius: 4px;
        border: 1px solid #99999930;
        color: #ccc;
        box-shadow: 0px 6px 8px 0px #00000060;
    }
    .root-alert .title {
        padding: 16px 16px 8px 16px;
        font-size: 18px;
        color: white;
    }
    .root-alert .errors {
        overflow-y: auto;
        padding: 0px 16px 24px 16px;
    }
    .root-alert .errors > * {
        margin-bottom: 4px;
    }
    .root-alert button {
        width: fit-content;
        padding: 6px 36px;
        margin: 16px auto;
        border-radius: 4px;
    }
    .root-alert ul {
        margin: 0px;
    }
</style>
